<template>
  <v-app-bar
    app
    clipped-left
    clipped-right
    color="header"
    :data-testid="getTestId('header-app-bar')"
  >
    <!-- <v-app-bar-nav-icon @click="toggleLeftDrawer = !toggleLeftDrawer"></v-app-bar-nav-icon> -->
    <!--    <v-app-bar-nav-icon @click="toggleLeftDrawer"></v-app-bar-nav-icon>-->
    <div
      class="mx-2 d-flex align-center cursor-pointer"
      :data-testid="getTestId('header-logo')"
      @click="goHome"
    >
      <v-img
        :src="headerLogoSrc"
        :max-height="headerHeight"
        width="60"
        contain
        alt="Solvit"
      />
    </div><v-app-bar-nav-icon
      :color="headerBarNavTone"
      :data-testid="getTestId('header-menu-toggle')"
      @click="toggle"
    />
    <v-tabs
      v-model="locationTab"
      :color="headerBarNavTone"
      slider-color="primary"
      :data-testid="getTestId('header-navigation-tabs')"
    >
      <v-tab
        v-for="(item, i) in menuItems"
        :key="i"
        class="font-weight-bold"
        :class="[headerNavTabTextClass, { active: isMatchingPath(item.location) }]"
        :data-testid="getTestId(`header-tab-${item.key}`)"
        @click="goTo(item.location)"
      >
        <v-icon :color="headerBarNavTone" class="mr-2">
          {{ item.icon }}
        </v-icon>
        {{ item?.key }}
      </v-tab>
    </v-tabs>
    <v-spacer />
    <!-- 드론 이미지 위치 분석 드롭다운 메뉴 (dashboard 페이지에서만 표시) -->
    <v-menu
      v-if="isDashboardPage"
      offset-y
      :z-index="200"
      content-class="drone-image-analysis-menu solvit-header-menu"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-tooltip bottom z-index="102">
          <template slot="activator" slot-scope="{ on: tooltipOn, attrs: tooltipAttrs }">
            <v-btn
              icon
              v-bind="{ ...attrs, ...tooltipAttrs }"
              :data-testid="getTestId('header-image-marker-icon')"
              v-on="{ ...on, ...tooltipOn }"
              :loading="isProcessingFiles"
              :disabled="isProcessingFiles"
            >
              <v-icon v-if="!isProcessingFiles" :color="headerBarNavTone">
                mdi-image-marker
              </v-icon>
            </v-btn>
          </template>
          <span style="word-break: keep-all">
            {{
              isProcessingFiles
                ? $t('header.imageAnalysisInProgress')
                : $t('header.droneImageAnalysis')
            }}
          </span>
        </v-tooltip>
      </template>
      <v-list dense>
        <v-list-item
          dense
          @click="showImageLocations('time')"
          :disabled="isProcessingFiles"
        >
          <v-list-item-icon class="align-self-center mr-2">
            <v-icon small>mdi-clock-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t('header.analyzeByShootingTime') }}</v-list-item-title>
            <v-list-item-subtitle>{{ $t('header.analyzeByShootingTimeHint') }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          dense
          @click="showImageLocations('filename')"
          :disabled="isProcessingFiles"
        >
          <v-list-item-icon class="align-self-center mr-2">
            <v-icon small>mdi-file-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t('header.analyzeByFileName') }}</v-list-item-title>
            <v-list-item-subtitle>{{ $t('header.analyzeByFileNameHint') }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
    <!-- <v-app-bar-nav-icon @click.stop="drawerRight = !drawerRight" /> -->
    <v-menu
      :close-on-content-click="false"
      offset-x
      offset-y
      :z-index="2000"
      content-class="header-user-menu solvit-header-menu"
      style="display: flex; align-items: center; gap: 8px"
      :data-testid="getTestId('header-user-menu')"
    >
      <template slot="activator" slot-scope="{ on: onMenu }">
        <v-tooltip bottom z-index="102" transition="false">
          <template slot="activator" slot-scope="{ on: onTooltip }">
            <v-btn
              icon
              style="margin: 0; padding: 0"
              :data-testid="getTestId('header-user-avatar')"
              v-on="{ ...onMenu, ...onTooltip }"
            >
              <v-avatar>
                <v-img
                  v-if="userProfile?.profImgUrl"
                  :src="userProfile.profImgUrl"
                  alt="Profile"
                />
                <v-icon
                  v-else
                  :color="headerBarNavTone"
                  size="xx-large"
                >
                  mdi-account-circle
                </v-icon>
              </v-avatar>
            </v-btn>
          </template>
          <span style="word-break: keep-all">{{ $t('user.menu') }}</span>
        </v-tooltip>
      </template>
      <v-card color="surface">
        <v-list dense class="pa-1" color="surface">
          <v-list-item dense :data-testid="getTestId('header-menu-profile')" @click="openDialog">
            <v-list-item-icon class="align-self-center mr-2">
              <v-icon small>
                mdi-account-search
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                {{ $t('user.accountInfo') }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item dense :data-testid="getTestId('header-menu-password')" @click="openPasswordDialog">
            <v-list-item-icon class="align-self-center mr-2">
              <v-icon small>
                mdi-lock-reset
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                {{ $t('user.password.title') }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item dense :data-testid="getTestId('header-menu-logout')" @click="logout">
            <v-list-item-icon class="align-self-center mr-2">
              <v-icon small>
                mdi-logout-variant
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                {{ $t('user.logout') }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider class="my-1" />
          <v-list-item dense :data-testid="getTestId('header-menu-language')">
            <v-list-item-icon class="align-self-center mr-2">
              <v-icon small>mdi-translate</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="solvit-header-menu__label">
                {{ $t('common.language') }}
              </v-list-item-title>
              <v-select
                :value="$i18n.locale"
                :items="localeOptions"
                item-text="text"
                item-value="value"
                dense
                hide-details
                outlined
                class="ma-0 pt-0 solvit-header-menu__select"
                @change="onLocaleChange"
              />
            </v-list-item-content>
          </v-list-item>
          <v-divider class="my-1" />
          <v-list-item dense :data-testid="getTestId('header-menu-theme-toggle')">
            <v-list-item-icon class="align-self-center mr-2">
              <v-icon small>{{ isDarkMode ? 'mdi-weather-night' : 'mdi-weather-sunny' }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{
                isDarkMode ? $t('common.darkMode') : $t('common.lightMode')
              }}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action class="my-0">
              <v-switch
                v-model="isDarkMode"
                inset
                dense
                hide-details
                class="ma-0 pa-0"
              />
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
    <UserProfileDialog
      :key="'profile-dialog-' + dialogKey"
      :dialog="dialog"
      :data-testid="getTestId('header-profile-dialog')"
      @update:dialog="dialog = $event"
    />
    <ChangePasswordDialog
      v-if="userProfile"
      :key="'password-dialog-' + dialogKey"
      :dialog="passwordDialog"
      :user-seq="userProfile?.id"
      access-type="me"
      :data-testid="getTestId('header-password-dialog')"
      @close="passwordDialog = false"
      @update:dialog="passwordDialog = $event"
    />
  </v-app-bar>
</template>

<script>
import { mapGetters } from 'vuex';
import ChangePasswordDialog from '../dialog/ChangePasswordDialog.vue';
import UserProfileDialog from '../dialog/UserProfileDialog.vue';
import { getTestId } from '@/utils/testUtils';
import { USER_ROLE_LABEL_I18N_KEY } from '@/utils/userI18nKeys';
import { setAppLocale } from '@/utils/localeUtils';
import { persistDarkMode } from '@/utils/themeStorage';
import { logout as authLogout } from '@/auth';

const EditDialogMode = {
  view: 'view',
  edit: 'edit',
  create: 'create'
};
export default {
  name: 'CoreHeader',
  components: {
    ChangePasswordDialog,
    UserProfileDialog
  },
  data: () => ({
    dialog: false,
    passwordDialog: false,
    userProfileMode: EditDialogMode.view,
    locationTab: window.location.pathname === '/dashboard' ? 0 : 1,
    dialogKey: 0,
    // 파일 처리 중복 방지
    isProcessingFiles: false
  }),
  computed: {
    /** 헤더 스위치 ↔ Vuetify 테마 ↔ localStorage 단일 소스 */
    isDarkMode: {
      get() {
        return this.$vuetify.theme.dark;
      },
      set(value) {
        this.$vuetify.theme.dark = value;
        persistDarkMode(value);
      }
    },
    ...mapGetters({ userProfile: 'user/getUserProfile' }),
    headerHeight() {
      return getComputedStyle(document.documentElement).getPropertyValue('--headerHeight');
    },
    /** 라이트: 컬러 로고 PNG, 다크: 흰색 로고 PNG */
    headerLogoSrc() {
      return this.$vuetify.theme.dark
        ? require('@/assets/image/solvit_logo_white.png')
        : require('@/assets/image/solvit_logo.png');
    },
    /** 탭·드론 분석·햄버거·사용자 아이콘: 다크는 흰색, 라이트는 거의 검정(퍼플 primary 미사용) */
    headerBarNavTone() {
      return this.$vuetify.theme.dark ? 'white' : 'grey darken-4';
    },
    headerNavTabTextClass() {
      return this.$vuetify.theme.dark ? 'white--text' : 'grey--text text--darken-4';
    },
    menuItems() {
      const items = [
        { key: this.$t('common.workspace'), location: '/dashboard', icon: 'mdi-map' }
      ];

      if (this.userProfile && this.userProfile.userRole === 'ADMIN') {
        items.push({
          key: this.$t('common.settings'),
          location: '/admin/project',
          icon: 'mdi-cog-outline'
        });
      }

      return items;
    },
    localeOptions() {
      return [
        { text: this.$t('common.languageKorean'), value: 'ko' },
        { text: this.$t('common.languageEnglish'), value: 'en' }
      ];
    },
    isDashboardPage() {
      return window.location.pathname === '/dashboard';
    }
  },
  methods: {
    goTo(location) {
      if (window.location.pathname === location) {
        return;
      }

      this.$router.push(location);
    },
    isMatchingPath(pathname) {
      return window.location.pathname === pathname;
    },
    toggle() {
      this.$eventBus.$emit('toggle-drawer', {
        from: 'HeaderBar'
      });
    },
    goHome() {
      // this.$router.push({ path: "/" });
    },
    logout() {
      authLogout({ redirect: true, router: this.$router });
    },
    handleClose() {
      this.dialog = false;
    },
    openDialog() {
      this.dialog = true;
    },
    openPasswordDialog() {
      this.passwordDialog = true;
    },
    getRoleLabel(role) {
      const key = USER_ROLE_LABEL_I18N_KEY[role];
      return key ? this.$t(key) : role;
    },
    getTestId(testId) {
      return getTestId(testId);
    },
    onLocaleChange(locale) {
      setAppLocale(this.$i18n, this.$vuetify, locale);
    },
    showImageLocations(sortOrder = 'time') {
      // 파일 처리 중이면 무시
      if (this.isProcessingFiles) {
        console.log('File processing in progress, ignoring showImageLocations call');
        return 0;
      }
      
      // 로딩 상태 시작
      this.isProcessingFiles = true;
      
      // 이벤트 버스를 통해 DotSolarMapBox에 파일 선택 요청 전달 (정렬 방식 포함)
      this.$eventBus.$emit('show-images-location', {
        sortOrder: sortOrder
      });
      
      // 로딩 상태 해제를 위한 이벤트 리스너 등록
      this.$eventBus.$once('image-processing-complete', () => {
        this.isProcessingFiles = false;
      });
    }
  }
};
</script>

<style>
/* 헤더 드롭다운: 맵 AI 중복제거 메뉴(dense)와 비슷한 밀도 */
.drone-image-analysis-menu {
  z-index: 200 !important;
}

.solvit-header-menu .v-list-item {
  min-height: 36px !important;
}

.solvit-header-menu .v-list-item__title {
  font-size: 0.8125rem !important;
  font-weight: 500 !important;
  line-height: 1.25 !important;
}

.solvit-header-menu .v-list-item__subtitle {
  font-size: 0.75rem !important;
  line-height: 1.25 !important;
  opacity: 0.72;
}

.solvit-header-menu .v-list-item__icon {
  margin-right: 8px !important;
  min-width: 24px !important;
}

.solvit-header-menu .solvit-header-menu__label {
  font-size: 0.75rem !important;
  font-weight: 500 !important;
  opacity: 0.72;
  margin-bottom: 4px !important;
}

.solvit-header-menu .solvit-header-menu__select {
  font-size: 0.8125rem;
}

.solvit-header-menu .solvit-header-menu__select .v-input__slot {
  min-height: 32px !important;
}
</style>
